export enum ScenarioSharing {
    private = 'private',
    public = 'public',
}
